import { render, staticRenderFns } from "./CorpField.vue?vue&type=template&id=40794624&scoped=true"
import script from "./CorpField.vue?vue&type=script&lang=ts"
export * from "./CorpField.vue?vue&type=script&lang=ts"
import style0 from "./CorpField.vue?vue&type=style&index=0&id=40794624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40794624",
  null
  
)

export default component.exports